// The maturity-ladder legend shown while scoring, so raters know exactly what
// each 1–5 level means. Mirrors the rubric: scored at the highest level whose
// criteria are fully met. Collapsible, open by default.

import { MATURITY_LADDER } from '@dwa/shared';
import { useState } from 'react';

// Ascending colour grade (low = muted, high = vibrant) — also gives the page
// some colour beyond the teal canvas.
const BADGE = [
  'bg-climb-mute-2 text-white',
  'bg-climb-sage text-climb-ink',
  'bg-climb-teal-soft text-climb-ink',
  'bg-climb-cyan text-climb-ink',
  'bg-climb-coral text-white',
];

export function ScaleLegend() {
  const [open, setOpen] = useState(true);
  return (
    <section className="rounded-xl border border-climb-line-dark bg-climb-surface-2/60 p-4">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 text-left"
      >
        <span className="text-sm font-semibold text-climb-paper">
          How to score — the maturity ladder{' '}
          <span className="font-normal text-climb-teal-soft">(1 = Absent … 5 = Optimizing)</span>
        </span>
        <span className="shrink-0 text-sm text-climb-cyan">{open ? '▴ Hide' : '▾ Show'}</span>
      </button>
      <p className="mt-1 text-xs text-climb-teal-soft">
        Score each question at the <strong className="text-climb-paper">highest level whose criteria are fully met</strong>.
      </p>
      {open ? (
        <ul className="mt-3 space-y-2">
          {MATURITY_LADDER.map((level, i) => (
            <li key={level.value} className="flex gap-3">
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-mono text-sm font-semibold ${BADGE[i]}`}
              >
                {level.value}
              </span>
              <div className="text-sm">
                <span className="font-semibold text-climb-paper">{level.name}</span>
                <span className="text-climb-paper/70"> — {level.criteria}</span>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
